// @flow

export const isTouchDevice = (): boolean => {
    return (
        Boolean('ontouchstart' in window) ||
        Boolean(window.navigator && (window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints))
    );
};
